import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'users.manage.settings';
export const CustomersSettingsApi = NormalizeApi({
  view: `${BASE_ENDPOINT}.view`,
  update: `${BASE_ENDPOINT}.update`
});